import React from 'react';
import PropTypes from 'prop-types';

import './registration-bonus-view.scss';
import { FormattedTag } from 'core/components';
import { FormattedMessage } from 'react-intl';
import { getStaticUrl } from 'core/helpers';
import classNames from 'classnames';
import { IconSandClock } from '../../icons/icon-sand-clock/icon-sand-clock';
import { CustomCountdown } from '../../custom-countdown/custom-countdown';
import { IconPresent } from '../../icons/icon-present/icon-present';
import { usePrevious } from '../../../hooks/usePrevious';

const staticUrl = getStaticUrl();

const formatTime = time => String(time).length > 1 ? time : `0${time}`;

const RegistrationBonusViewUI = ({
  bonus,
  buttons,
  className,
  isHeader,
}) => {
  const prevBonus = usePrevious(bonus);

  if (prevBonus?.bonusPlanId !== bonus?.bonusPlanId) {
    return null;
  }

  return (
    <div
      className={classNames('position-relative w-100 bg-primary rounded d-sm-flex d-block justify-content-between', className)}
    >
      <div className={classNames('d-flex bonus-description', { 'justify-content-between': isHeader })}>
        <div className="image-substitute d-sm-block d-none" />
        <img
          className={classNames('image position-absolute d-sm-block d-none', { 'h-100 mb-0_25': isHeader })}
          src={`${staticUrl}/images/profile-promo/registration-bonus/present.png`}
          alt="present"
        />

        <div className={classNames('d-sm-flex d-block mb-sm-0 mb-3', { 'mb-6': bonus?.hasNoExpiry })}>
          <div className={classNames('d-flex align-items-center', { 'ml-md-10 ml-0': !isHeader })}>
            <IconPresent
              className="icon"
            />

            <FormattedTag
              className="mx-1_5 font-weight-normal h4 text-nowrap"
              id="gifts.registration.bonus.title"
            />

            <FormattedMessage
              id={`gifts.registration.bonus.amount.${bonus?.bonusPlanId}`}
              values={{
                amount: bonus.amount,
              }}
            >
              {countdownHTML => (
                <span
                  className="font-weight-bold h2 text-gold-4 mb-0"
                  dangerouslySetInnerHTML={{ __html: countdownHTML }}
                />
              )}
            </FormattedMessage>
          </div>

          {bonus?.registrationExtendedExpiryDate && !(bonus?.hasNoExpiry) && (
            <div className={classNames('d-flex align-items-center mt-sm-0 mt-1',
              { 'ml-sm-2 ml-md-10 ml-0': !isHeader, 'ml-sm-4 ml-0': isHeader })}
            >
              <IconSandClock
                className="icon"
              />

              <FormattedTag
                className="mx-1_5 font-weight-normal h4 text-nowrap"
                id="gifts.registration.redeem.title"
              />

              <CustomCountdown date={bonus.registrationExtendedExpiryDate}>
                {({ days, formatted: { hours, minutes, seconds } }) => (
                  <span className="font-weight-bold h2 text-gold-4 mb-0 countdown-clock">
                    {`${formatTime(Number(days * 24) + Number(hours))}:${minutes}:${seconds}`}
                  </span>
                )}
              </CustomCountdown>
            </div>
          )}
        </div>

        <div className="image-substitute d-sm-none d-block" />
        <img
          className={classNames('image position-absolute d-sm-none d-block', { 'mr-2 h-75 h-sm-100': isHeader })}
          src={`${staticUrl}/images/profile-promo/registration-bonus/present.png`}
          alt="present"
        />

      </div>

      {buttons}
    </div>
  );
};

RegistrationBonusViewUI.propTypes = {
  bonus: PropTypes.shape(),
  buttons: PropTypes.node.isRequired,
  className: PropTypes.string,
  isHeader: PropTypes.bool.isRequired,
};

RegistrationBonusViewUI.defaultProps = {
  bonus: {},
  className: '',
};

export const RegistrationBonusView = RegistrationBonusViewUI;
